module.exports = __webpack_public_path__ + "assets/img/FENCE.a4f3c601.png";